import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
      name: 'เมนู',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    code: {
      name: 'เลขที่',
      width: '6rem',
    },
    name: {
      name: 'ชื่อ',
      width: '1fr',
    },
    credit_days: {
      name: 'Credits',
      width: '8rem',
      filter: (val: string) => `${val || 0} วัน`,
      class: 'text-right',
    },
    updated_at: {
      name: 'ทำรายการล่าสุด',
      width: '12rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
      class: 'text-right',
    },
    // userId: {
    //   name: 'ผู้ทำรายการ',
    //   width: '1fr',
    // },
  },

  sortable: [
    'code',
    'name',
    'updated_at',
  ],

};
